import { useNavigate } from "react-router-dom";
import { BackButton } from "../../styles/AddAdherense";
import {
  CancelPlansTitle,
  CancelPlanStyle,
  WrapContent,
  WrapTitleAndSmallText,
  SearchBar,
  SearchContainer,
  SearchIcon,
  Table,
  Th,
  Td,
  DeactivateButton,
  Select,
} from "../../styles/CancelPlan";
import { HOME_LOGGED } from "../../core/app-urls";
import { useEffect, useState } from "react";
import { getContractsPF } from "../../data/services/person_service";
import {
  destroyContractCancelRequest,
  getContractsByNumberAndCpf,
  getListOfCanceledPlans,
} from "../../data/services/enterprise_service";
import ContractBasicInfoModel from "../../data/models/contractBasic";
import { toast, ToastContainer } from "react-toastify";
import WitnessContractModel from "../../data/models/witness";
import InputMask from "react-input-mask";

export default function CancelPlans() {
  const navigate = useNavigate();
  const [contracts, setContracts] = useState<any[]>([]);
  const [selectedContractId, setSelectedContractId] = useState<string>("");
  const [cpfInput, setCpfInput] = useState<string>("");
  const [selectedContract, setSelectedContract] = useState<any | null>(null);
  const [searchedContract, setSearchedContract] =
    useState<ContractBasicInfoModel | null>(null);
  const [historicalContracts, setHistoricalContracts] = useState<
    WitnessContractModel[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [mode, setMode] = useState<"desativar" | "historico">("desativar");

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  const fetchContracts = async () => {
    setLoading(true);
    const response = await getContractsPF();
    if (response.data) {
      setContracts(response.data);
    } else {
      console.error("Não foi possível carregar os contratos.");
    }
    setLoading(false);
  };

  const handleSearch = async () => {
    if (!selectedContract || !cpfInput) return;
    setLoading(true);
    console.log(selectedContract.idContrato, "id")
    console.log(selectedContract.numero_contrato, "numero")
    const response = await getContractsByNumberAndCpf(
      // selectedContract.numero_contrato,
      selectedContract.idContrato,
      cpfInput
    );
    setSearchedContract(response.data);
    setLoading(false);
  };

  const handleDeactivate = async () => {
    if (!searchedContract) return;

    const cancelList = [
      {
        id_contrato: searchedContract.idContrato,
        motivo: 13,
        observacao: "",
      },
    ];

    const result = await destroyContractCancelRequest(cancelList);

    if (result) {
      toast.success("Contrato desativado com sucesso!");
      setSearchedContract(null);
      setCpfInput("");
    }
  };

  useEffect(() => {
    fetchContracts();
  }, []);

  return (
    <CancelPlanStyle>
      <ToastContainer />
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <WrapTitleAndSmallText>
          <CancelPlansTitle>Desativar planos</CancelPlansTitle>
          <p>
            Selecione o número do contrato e busque o colaborador pelo CPF para
            poder desativar o plano, ou acesse o histórico de planos
            desativados.
          </p>
        </WrapTitleAndSmallText>

        <div style={{ display: "flex", gap: "10px", marginBottom: "1rem" }}>
          <button
            onClick={() => setMode("desativar")}
            style={{
              padding: "8px 16px",
              backgroundColor: mode === "desativar" ? "#333" : "#ccc",
              color: mode === "desativar" ? "#fff" : "#000",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Desativar Planos
          </button>
          <button
            onClick={() => setMode("historico")}
            style={{
              padding: "8px 16px",
              backgroundColor: mode === "historico" ? "#333" : "#ccc",
              color: mode === "historico" ? "#fff" : "#000",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Histórico
          </button>
        </div>

        <Select
          value={selectedContract?.idContrato || ""}
          onChange={async (e) => {
            const contractId = e.target.value;

            const contract = contracts.find(
              (c) => String(c.idContrato) === contractId
            );

            setSelectedContract(contract || null);
            setSearchedContract(null);

            if (!contract) return;

            setLoading(true);
            const response = await getListOfCanceledPlans(contract.idContrato);
            setHistoricalContracts(response.data || []);
            setLoading(false);
          }}
        >
          <option value="">Selecione o número do contrato</option>
          {contracts.map((contract) => (
            <option key={contract.idContrato} value={contract.idContrato}>
              {contract.numero_contrato}
            </option>
          ))}
        </Select>

        {mode === "desativar" && (
          <SearchContainer isExpanded={true} style={{ cursor: "pointer" }}>
            <InputMask
              mask="99999999999"
              value={cpfInput}
              onChange={(e) => setCpfInput(e.target.value)}
            >
              {(inputProps: any) => (
                <SearchBar
                  {...inputProps}
                  placeholder="Busque o CPF aqui (Somente Números)"
                  type="text"
                />
              )}
            </InputMask>
            <SearchIcon
              size={20}
              onClick={handleSearch}
              style={{ cursor: "pointer" }}
            />
          </SearchContainer>
        )}

        <div style={{ maxHeight: "400px", overflowY: "auto", width: "100%" }}>
          {mode === "desativar" ? (
            <Table>
              <thead>
                <tr>
                  <Th>NOME</Th>
                  <Th>CPF</Th>
                  <Th>PLANO</Th>
                  <Th>Desativar</Th>
                </tr>
              </thead>
              <tbody>
                {searchedContract ? (
                  <tr>
                    <Td>{searchedContract.nome}</Td>
                    <Td>{searchedContract.cpf}</Td>
                    <Td>{searchedContract.categoria}</Td>
                    <Td>
                      {searchedContract.cancelado ? (
                        <span style={{ color: "gray", fontStyle: "italic" }}>
                          Plano já cancelado
                        </span>
                      ) : (
                        <DeactivateButton onClick={handleDeactivate}>
                          Desativar
                        </DeactivateButton>
                      )}
                    </Td>
                  </tr>
                ) : (
                  <tr>
                    <Td colSpan={4} style={{ textAlign: "center" }}>
                      {loading
                        ? "Carregando..."
                        : "Nenhum resultado encontrado."}
                    </Td>
                  </tr>
                )}
              </tbody>
            </Table>
          ) : (
            <Table>
              <thead>
                <tr>
                  <Th>NOME</Th>
                  <Th>CPF</Th>
                  <Th>CONTRATO</Th>
                  <Th>STATUS</Th>
                  <Th>DATA CANCELAMENTO</Th>
                  <Th>Meio de cancelamento</Th>
                </tr>
              </thead>
              <tbody>
                {historicalContracts.length > 0 ? (
                  historicalContracts.map((contract, index) => (
                    <tr key={index}>
                      <Td>{contract.nomeAssociado}</Td>
                      <Td>{contract.cpfAssociado}</Td>
                      <Td>{contract.num_contrato}</Td>
                      <Td>{contract.status}</Td>
                      <Td>
                        {new Date(contract.dataFinal).toLocaleDateString(
                          "pt-BR"
                        )}
                      </Td>
                        <Td>{contract.userCancel}</Td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <Td colSpan={3} style={{ textAlign: "center" }}>
                      {loading
                        ? "Carregando..."
                        : "Nenhum resultado encontrado."}
                    </Td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>
      </WrapContent>
    </CancelPlanStyle>
  );
}
